import { FC } from "react";
import { Box, Divider, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const StrongDivider = withStyles({
  root: {
    backgroundColor: "#2A313B",
  },
})(Divider);

interface TotalYieldEquationProps {
  showSaleProceeds: boolean;
}

const TotalYieldEquation: FC<TotalYieldEquationProps> = ({
  showSaleProceeds,
}) => (
  <Box textAlign="center">
    <Typography component="div" style={{ fontSize: "13px" }}>
      {showSaleProceeds
        ? "Royalties Received + Sale Proceeds"
        : "Royalties Received"}
    </Typography>
    <Box my={1}>
      <StrongDivider />
    </Box>
    <Typography component="div" style={{ fontSize: "13px" }}>
      Purchased Price
    </Typography>
  </Box>
);

export default TotalYieldEquation;
